<template>
  <section id="features" class="features">
    <div class="container">
      <div class="section-header">
        <h2>Professional <span class="highlight">FM Radio Experience</span></h2>
        <p>Thoughtfully crafted for radio enthusiasts</p>
      </div>
      
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M174.5 448.7c-4.2-2.4-6.8-6.8-6.8-11.7c0-7.3 5.9-13.3 13.3-13.3h45.3V384H152c-22.1 0-40-17.9-40-40V132.8l47-27.7V160H360.8l56.4-33.3-32.5-34.2c-9.8-10.3-14.1-24.7-11.8-38.8l5.7-33.6c1.3-8.2 8.5-14.1 16.7-14.1h31c8.3 0 15.4 5.9 16.7 14.1l5.7 33.6c2.3 14-2 28.5-11.8 38.8l-32.5 34.2L472 160v184c0 22.1-17.9 40-40 40H336v39.7h45.3c7.3 0 13.3 5.9 13.3 13.3c0 4.9-2.7 9.4-6.8 11.7L241.2 510.4c-7 4-15.6 4-22.6 0L174.5 448.7zM226.3 384L304 384V325.3l16-16V384h72c4.4 0 8-3.6 8-8V179.8l-35.3 20.8H136V368c0 4.4 3.6 8 8 8l82.3 0z"/>
            </svg>
          </div>
          <h3>Global Stations</h3>
          <p>Access over 1000 premium FM/AM radio stations from around the world, easily tune in to domestic and international broadcasts</p>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
              <path fill="currentColor" d="M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.8 136.8 101.5 128 79 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c14 0 27.2-3.6 38.7-9.9L267.6 415.4c-11.5 22.1-10.1 48.9 4.3 69.8c18.9 27.8 56.8 35.1 84.5 16.2c27.8-18.9 35.1-56.8 16.2-84.5c-13.8-20.4-38.9-30.2-63-25.1L159.7 255.4c3.2-8.7 5-18.2 5-28c0-1.1 0-2.2-.1-3.3L348.5 205c15.5 33.4 52.5 52.2 90.8 43.4l108.9 123.2c-11 12 .1 32.8 16.9 34.3c20.6 1.8 27.6-9.9 32.9-19.5c7.5-13.6-.2-30.2-13.7-33.7c-5.1-2.7-17.3-1.5-24.6 6.7l-108.1-122c9.3-8 16.6-18 21.8-29.3l106.9 92c11 19.6 45.9 9.2 45.3-18.5c-.6-28-33.8-32.5-45.6-14.3L461.9 166.9c8.6-15.6 13.1-33.2 10-50.7c-4.1-22.7-21-41.5-42.9-50.5c-30.5-12.5-68.9-1.7-86.2 25.2L142.5 113.5c-.1-1.8-.2-3.7-.2-5.5c0-13.7 3.5-26.5 9.6-37.7C164.7 47.2 126.9 11 80 11C35.8 11 0 46.8 0 91c0 37.9 26.3 69.7 61.6 77.9l-3.3 3.9c-10.1 12.2-15.9 27.8-15.9 44.2c0 18 6.7 35.1 18.9 48.3l95.8 105.4c-4.6 13.1-5 27.8-.5 41.7c7.1 22 25 39.4 47.3 46s46.8 1.5 66.2-14.4c19.6-16 28-40.9 22.7-64.9c-4.4-20-18.2-37.2-37-46.3L311 300.7c1.3-5.3 2-10.7 2-16.2c0-12.8-3.5-25.4-10-36.3L490.4 114.9c14.8 13.3 35.3 20.1 55.7 15.7c20.1-4.3 37.3-18.3 46.1-37.2c6.6-14.8 6.5-31.2 1.5-45.9C584.1 20.6 553.9 .4 529.5 .4c-19.3 0-37.8 8-50.8 22.1L456.2 46.1c-15.5-13.9-36.4-21.3-57.4-17.6c-23.6 4.3-41.2 17.8-52.4 32.7l-262.9 55c-10.3-9.8-24.2-15.9-39.5-15.9c-31.5 0-57 25.5-57 57s25.5 57 57 57c21.2 0 39.7-11.6 49.5-28.8l294.9-65.2c8 7.1 17.8 12.5 29.2 14.9c15.9 3.3 33.5-.7 47.9-11.9l18.4-14.3c15.1-11.6 34.4-15.5 52.7-11.6c4.5 1 8.4-2.5 8.4-6.9c0-3.3-2.2-6.1-5.3-7zM79 176c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM313.3 421.5c5.6 8.2 17.1 10.3 25.3 4.7s10.3-17.1 4.7-25.3s-17.1-10.3-25.3-4.7s-10.3 17.1-4.7 25.3zM529.5 67c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24z"/>
            </svg>
          </div>
          <h3>Smart Recommendations</h3>
          <p>Intelligently recommends stations and programs based on your listening habits, helping you discover more great content</p>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
              <path fill="currentColor" d="M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"/>
            </svg>
          </div>
          <h3>High-Definition Audio</h3>
          <p>Featuring advanced audio processing technology for clear, noise-free sound quality, supporting multiple audio formats</p>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M126.8 248.3c39.7-58.6 77.9-92.8 177.7-92.8 11.3 0 20.4-9.1 20.4-20.4s-9.1-20.4-20.4-20.4c-122.7 0-177.2 46-221.2 112.3-9.5 14.4-16.1 18.8-33.2 18.8h-8.3C18.4 246.7 0 265.1 0 288s18.4 41.3 41.8 41.3h8.3c32.3 0 52.6-34.9 76.7-81zm378.3 5.9c0-48.8-39.6-88.4-88.4-88.4s-88.4 39.6-88.4 88.4c0 13.6 3.1 26.5 8.6 38l-29.8 29.8-39-39c-9.4-9.4-24.6-9.4-33.9 0-9.4 9.4-9.4 24.6 0 33.9l39 39-95.9 95.9c-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0l95.9-95.9 39 39c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.4-24.6 0-33.9l-39-39L362 308.3c11.5 5.5 24.4 8.6 38 8.6 48.8 0 88.4-39.6 88.4-88.4zm-120.8 0c0-17.9 14.5-32.4 32.4-32.4s32.4 14.5 32.4 32.4-14.5 32.4-32.4 32.4c-17.9 0-32.4-14.5-32.4-32.4z"/>
            </svg>
          </div>
          <h3>Timer Functions</h3>
          <p>Includes sleep timer and alarm clock features, allowing you to enjoy your favorite radio programs while falling asleep or waking up</p>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"/>
            </svg>
          </div>
          <h3>Record & Playback</h3>
          <p>Record your favorite programs anytime, save content for offline listening and repeated playback</p>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/>
            </svg>
          </div>
          <h3>Personalization</h3>
          <p>Choose from multiple themes and interface layouts, customize station categories and favorites to create your own listening space</p>
        </div>
      </div>
      
      <div class="features-footer">
        <a href="#download" class="btn btn-primary">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18">
            <path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
          </svg>
          Try It Now
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection'
}
</script>

<style scoped>
.features {
  padding: 8rem 0;
  background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
  position: relative;
  overflow: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  position: relative;
  z-index: 2;
}

.section-header {
  text-align: center;
  margin-bottom: 5rem;
  animation: fade-in 1s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-header h2 {
  font-size: 3.2rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  color: #1e293b;
  position: relative;
  display: inline-block;
}

.highlight {
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 0 0.5rem;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  border-radius: 2px;
  opacity: 0.5;
}

.section-header p {
  font-size: 1.4rem;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
  margin-bottom: 5rem;
}

.feature-card {
  background: white;
  border-radius: 1.8rem;
  padding: 3rem;
  box-shadow: 0 15px 50px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid rgba(226, 232, 240, 0.8);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.feature-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.12);
  border-color: rgba(59, 130, 246, 0.3);
}

.feature-card:hover::before {
  opacity: 1;
}

.feature-icon {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: rgba(59, 130, 246, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  color: #3b82f6;
  transition: all 0.4s ease;
  transform: rotate(0deg);
}

.feature-card:hover .feature-icon {
  transform: rotate(5deg) scale(1.05);
  background: rgba(59, 130, 246, 0.15);
}

.feature-icon svg {
  width: 42px;
  height: 42px;
}

.feature-card h3 {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1.2rem;
  color: #1e293b;
  position: relative;
  display: inline-block;
}

.feature-card h3::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  border-radius: 2px;
  opacity: 0;
  transition: opacity 0.4s ease, width 0.4s ease;
}

.feature-card:hover h3::after {
  opacity: 1;
  width: 60px;
}

.feature-card p {
  font-size: 1.1rem;
  color: #64748b;
  line-height: 1.7;
}

.features-footer {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  padding: 1.2rem 2.5rem;
  border-radius: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s;
  font-size: 1.2rem;
  letter-spacing: 0.5px;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  box-shadow: 0 12px 25px rgba(37, 99, 235, 0.3);
  position: relative;
  overflow: hidden;
}

.btn-primary::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: rotate(30deg);
  transition: transform 0.5s;
}

.btn-primary:hover {
  transform: translateY(-5px);
  box-shadow: 0 18px 35px rgba(37, 99, 235, 0.4);
}

.btn-primary:hover::after {
  transform: rotate(30deg) translate(80%, 0);
}

@media (max-width: 1200px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .section-header h2 {
    font-size: 2.8rem;
  }
}

@media (max-width: 640px) {
  .features {
    padding: 6rem 0;
  }
  
  .section-header {
    margin-bottom: 3.5rem;
  }
  
  .section-header h2 {
    font-size: 2.4rem;
  }
  
  .section-header p {
    font-size: 1.2rem;
  }
  
  .feature-card {
    padding: 2.5rem;
  }
  
  .feature-icon {
    width: 70px;
    height: 70px;
    margin-bottom: 1.5rem;
  }
  
  .feature-icon svg {
    width: 36px;
    height: 36px;
  }
  
  .feature-card h3 {
    font-size: 1.6rem;
  }
  
  .feature-card p {
    font-size: 1rem;
  }
  
  .btn {
    padding: 1rem 2rem;
    font-size: 1.1rem;
  }
}
</style> 